<template>
  <el-row class="hidden-md-and-down">
    <el-col :span="this.isManager() ? 18 : 24" v-if="this.rowData.organisation">
      <contacts-popover :row-data="rowData" title="Authority" icon="fa fa-gavel" />
    </el-col>

    <el-col :span="4">
      <el-button v-if="isManager('admin|finance|property')" icon="fa fa-trash-alt" @click="deleteEntry()" size="small" type="danger" circle></el-button>
    </el-col>
  </el-row>
  </template>

  <script>

  import PostMixins from '@/mixins/PostMixins'
  import ContactsPopover from '@/components/atoms/ContactsPopover'

  export default {
    mixins: [PostMixins],

    components: {
      ContactsPopover
    },

    props: {
      rowData: {
        type: Object,
        required: true
      },
      tableRef: {
        type: String,
        default: 'permittable'
      }
    },
    methods: {
      deleteEntry () {
        this.deleteItem(this, this.rowData.id, '/permits', this.rowData.permitType, this.onDelete)
      },
      onDelete (response) {
        this.$events.fire(this.tableRef + '-refresh-table')
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// PermitControls.vue?1a92746e